var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowitworks4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1037_1392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 32.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 32,
    stroke: "#F58634"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2012 43.1289H36.5104V34.8557H33.2012V43.1289ZM34.8558 31.5464C35.3246 31.5464 35.7176 31.3878 36.0347 31.0707C36.3519 30.7535 36.5104 30.3605 36.5104 29.8917C36.5104 29.4229 36.3519 29.0299 36.0347 28.7128C35.7176 28.3957 35.3246 28.2371 34.8558 28.2371C34.387 28.2371 33.994 28.3957 33.6769 28.7128C33.3597 29.0299 33.2012 29.4229 33.2012 29.8917C33.2012 30.3605 33.3597 30.7535 33.6769 31.0707C33.994 31.3878 34.387 31.5464 34.8558 31.5464ZM21.6187 49.7474V29.8917L34.8558 19.9639L48.0929 29.8917V49.7474H21.6187ZM24.9279 46.4382H44.7837V31.5464L34.8558 24.1005L24.9279 31.5464V46.4382Z",
    fill: "#F58634"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1037_1392",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1037_1392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1037_1392",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworks4);
export default __webpack_public_path__ + "static/media/howitworks4.a9e1df1231ac2c34c0a74650ca4cb80b.svg";
export { ForwardRef as ReactComponent };